<template>
  <v-app>
    <v-app-bar
      app
      color="white"
      height="100"
    >
      

      <v-toolbar-title class="d-none d-md-flex">
        <v-row>
          <v-col cols="12 mb-0 pb-0">
            <h2 class="font-weight-black">CIRCUITO DE PALESTRAS DE COMPUTAÇÃO</h2>
          </v-col>
          <v-col cols="12 pt-0 mt-0">
            <span class="text-md-subtitle-1 font-weight-bold"> IFRS - IBIRUBÁ/RS - 20 a 24/07/2020 e 27 a 31/07/2020</span>
          </v-col>
        </v-row>
         
      </v-toolbar-title>

      <v-toolbar-title class="d-flex d-sm-none d-none d-sm-flex d-md-none font-weight-black text-sm-body-1 headline">
        Circuito de Palestras<br>IFRS - Ibirubá
      </v-toolbar-title>
    
    
    
    </v-app-bar>

    <v-main>
      
      <v-sheet
        id="contact"
        color="#333333"
        dark
        tag="section"
        tile
      >
        <div class="py-12"></div>

        <v-container>
          <v-responsive class="mx-auto mb-12">
            <h4 class="text-md-h4 text-sm-body-2 text-lg-h4 font-weight-bold mb-3 text-uppercase text-center">Lista de Presenças</h4>
          </v-responsive>

          <v-responsive
            class="mx-auto mb-12"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

              <v-row> 
                <v-col cols="12">
                    <h2>comentários:</h2>
                </v-col>
                
                <v-col cols="12">
                    <v-data-table
                        dense
                        :headers="headers"
                        :items="comentarios"
                        :items-per-page="20"
                        class="elevation-1"
                        :search="search"
                    >
                    </v-data-table>
                </v-col>
            </v-row> 

            <v-row>
                <v-col cols="12">
              <h2 class="text-center">Lista de Presenças Total</h2>
              <h3 class="text-center">Exporte para CSV</h3>
                </v-col>
          
                <v-col cols="12">
                    <v-list>
                        <v-list-item v-for="presenca of presencas" :key="presenca.usuarioEmail">{{presenca.palestraTitulo}},{{presenca.usuarioEmail}},{{presenca.dataAssinatura}}</v-list-item>
                    </v-list>
                </v-col>
            </v-row>
        
        </v-container>

        <div class="py-12"></div>
      </v-sheet>
    </v-main>

    <v-footer
      class="justify-center"
      color="#292929"
      height="100"
    >
      <div class="title font-weight-light grey--text text--lighten-1 text-center">
        &copy; {{ (new Date()).getFullYear() }} — Computação - IFRS - Ibirubá
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import moment from 'moment'

export default {
  name: 'App',

  data: () => ({
    search: '',
    headers: [
        
        { text: 'Palestra', value: 'palestra' },
        { text: 'Comentário', value: 'comentario' },
    ],
    
    presencas: [],
    comentarios: [],
  }),

  async created() {
      try{
          this.$http.get('presenca.json').then(
                res => {
                    for (const [key, value] of Object.entries(res.data)) {
                        this.presencas.push(
                          {
                              usuarioEmail: value.usuarioEmail.toLowerCase(),
                              palestraTitulo: value.palestraTitulo,
                              palestraComentario: value.palestraComentario,
                              dataAssinatura: moment(value.dataAssinatura).format('DD/MM/YYYY h:m:s'),
                              palestraRatingPalestra: value.palestraRatingPalestra,
                              palestraRatingTransmissao: value.palestraRatingTransmissao,
                              palestraRatingDuracao: value.palestraRatingDuracao,
                              palestraId: value.paletraId,
                              key: key
                          }
                        )
                        if(value.palestraComentario != ""){
                            this.comentarios.push({
                                palestra: value.palestraTitulo,
                                comentario: value.palestraComentario
                            })
                        }
                    }
                }
            )        
      }catch(e){
          console.log("Houve erro: " + e)
      }
  },
};
</script>
